import Grid from '@mui/material/Unstable_Grid2'
import {Box, Container} from '@mui/material'

export const PageContainer = (props) => (
    <Container maxWidth={"md"} sx={{...props.containerSx}}>
        <Box sx={{margin: "1em 0", justifyContent: "center",
            display: "flex", flexDirection: "column", ...props.boxSx}}>
            {props.children}
        </Box>
    </Container>

)
export const ItemContainer = (props) => (
    <Grid container display={"flex"} direction={'column'}  {...props}>
        {props.children}
    </Grid>
)

export const ButtonContainer = (props) => (
    <Grid display={"flex"}
          sx={{
              justifyContent: "flex-end",
              alignSelf: "flex-end",
              alignItems: "flex-start",
              ...props.sx
          }}>
        {props.children}
    </Grid>
)